const getters = {
  getBasicServices: (state) => state.basicServices,
  getBasicService: (state) => state.basicService,
};

export default getters;